export const throttle = (fn, ms = 250, scope) => {
  let last;
  let deferTimer;

  return function wrapper(...args) {
    const context = scope || this;
    const now = +new Date();

    if (last && now < last + ms) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(() => {
        last = now;
        fn.apply(context, args);
      }, ms);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
};

export default throttle;



// WEBPACK FOOTER //
// ./src/common/utils/throttle.js